import { CUSTOM_EVENT_TYPE } from "./custom-event";

export function onlyCustomEvents(type: string): boolean {
    return type.toUpperCase() === CUSTOM_EVENT_TYPE.toUpperCase();
}
